import * as React from 'react';
import { useCallback } from 'react';
import { ChangeEvent } from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { renderEditField } from './InputValueEditor';
import type { UserDefinedType, DataType, UnionDataType, DataValue } from '@glueapp/graph-types';
import { getStringRepresentationFromType, getDefaultValueForDataType, matchesDataType } from '@glueapp/graph-types';
interface UnionValueEditorProps {
    type: UnionDataType;
    value: DataValue;
    userDefinedType?: UserDefinedType;
    onChange: (value: DataValue, updatedType?: UserDefinedType) => void;
}

export const UnionValueEditor: React.FC<UnionValueEditorProps> = ({ type, value, userDefinedType, onChange }) => {
    const handleSelectChange = useCallback(
        (event: ChangeEvent<HTMLSelectElement>) => {
            const index = parseInt(event.target.value, 10);
            const matchingOption = type.subTypes[index];
            if (matchingOption) {
                const newValue = !matchesDataType(value, matchingOption) ? getDefaultValueForDataType(matchingOption) : value;
                onChange(newValue, { kind: 'union', selectedTypeIndex: index });
            }
        },
        [type, onChange, value],
    );

    const selectedOption: DataType =
        userDefinedType && userDefinedType.kind === 'union'
            ? (type.subTypes[userDefinedType.selectedTypeIndex] ?? type.subTypes[0])
            : type.subTypes[0];

    return (
        <div className="flex flex-col pt-1">
            <Select
                value={String(userDefinedType?.kind === 'union' ? userDefinedType.selectedTypeIndex : 0)}
                onValueChange={value => handleSelectChange({ target: { value } } as ChangeEvent<HTMLSelectElement>)}
            >
                <SelectTrigger>
                    <SelectValue />
                </SelectTrigger>
                <SelectContent>
                    {type.subTypes.map((subType, index) => (
                        <SelectItem key={index} value={String(index)}>
                            {getStringRepresentationFromType(subType)}
                        </SelectItem>
                    ))}
                </SelectContent>
            </Select>
            {renderEditField(selectedOption, value, userDefinedType, onChange)}
        </div>
    );
};
